import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { FotoKategorienQuerySorterConfig } from 'fa-kt.types';
import { FotoKategorienService } from '../service';

@Component({
  selector: 'fa-kt-foto-kategorien-sorter',
  templateUrl: './foto-kategorien-sorter.component.html',
  styleUrls: ['./foto-kategorien-sorter.component.css'],
})
export class FotoKategorienSorterComponent {
  FotoKategorienSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public fotoKategorien: FotoKategorienService,
  ) {
    this.FotoKategorienSorterConfig = FotoKategorienQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
